/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rankings_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading rankings..." |
*
* @param {Rankings_LoadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_loading = /** @type {((inputs?: Rankings_LoadingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_LoadingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des classements...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando clasificaciones...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Carregando classificações...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento classifiche...")
	return /** @type {LocalizedString} */ ("Loading rankings...")
});